// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gdIen{display:flex;flex-direction:column;gap:.5rem;height:100%;line-height:1.7rem;margin-bottom:.25rem;width:100%}.gdIen ._5PGL{align-items:center;column-gap:1rem;display:grid;grid-template-columns:var(--kvl-label-width) max-content}.gdIen ._5PGL .YHroD.QPOfI{text-align:right}.gdIen .wAw0o{display:flex;flex-direction:column;gap:.1rem}.gdIen .wAw0o:last-child{text-wrap:wrap}.gdIen .wAw0o>.YHroD{align-self:baseline}.gdIen.GqgeQ ._5PGL,.gdIen.cTluL ._5PGL{grid-template-columns:var(--kvl-label-width) 1fr}.gdIen.cTluL ._5PGL{justify-content:space-between}.gdIen.cTluL ._5PGL .CQFvj{display:flex;justify-content:flex-end;justify-self:end}.gdIen .YHroD{align-self:center;flex:0 0 auto;font-weight:700}.gdIen .YHroD.rhAgz{align-self:flex-start}.gdIen .YHroD.OYzjM{white-space:nowrap}.gdIen .R5duq{text-transform:unset}.gdIen .CQFvj{color:var(--field-value-color,inherit);flex:0 1 auto;width:fit-content}.gdIen .CQFvj.B4S26{width:100%}.gdIen .CQFvj.MB54p{line-break:anywhere}.gdIen .CQFvj.uxP0R{overflow:hidden}.gdIen .xgi8t{box-shadow:none;margin-top:0}.gdIen .xgi8t .wIdB2{font-size:.85rem;margin:0;text-align:left;white-space:pre-wrap}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fields": `gdIen`,
	"fieldRowInline": `_5PGL`,
	"fieldLabel": `YHroD`,
	"rightAlign": `QPOfI`,
	"fieldRow": `wAw0o`,
	"fullWidthValues": `GqgeQ`,
	"justify": `cTluL`,
	"fieldValue": `CQFvj`,
	"topAlign": `rhAgz`,
	"noWrapLabel": `OYzjM`,
	"sectionTitle": `R5duq`,
	"fullWidth": `B4S26`,
	"forceWrap": `MB54p`,
	"noWrapValue": `uxP0R`,
	"objectValue": `xgi8t`,
	"jsonStrFmt": `wIdB2`
};
module.exports = ___CSS_LOADER_EXPORT___;
